import { Link, usePathname } from 'expo-router';
import { StyleSheet } from 'react-native';

import { useMenuClickEvents } from '@fhs/menu/src/analytics';
import { IconLocationFill, Pressable, Text, tokens } from '@fhs/ui';
import { useOrderContext } from '@fhs-legacy/frontend/src/state/order';
import { useServiceModeContext } from '@fhs-legacy/frontend/src/state/service-mode';
import { useStoreContext } from '@fhs-legacy/frontend/src/state/store';
import { routes } from '@fhs-legacy/frontend/src/utils/routing';

export function MenuLocationButton() {
  const { store } = useStoreContext();
  const { isDelivery } = useServiceModeContext();
  const { deliveryAddress } = useOrderContext();
  const pathname = usePathname();
  const { logServiceModeBarClick } = useMenuClickEvents();
  const serviceMode = isDelivery ? 'Delivery' : 'Pickup';
  const location = isDelivery
    ? deliveryAddress?.addressLine1
    : [store.name, store.physicalAddress?.address1].filter(Boolean).join(' · ');
  const label = location || 'Choose a location';

  return (
    <Link
      href={{
        pathname: isDelivery ? routes.address : routes.storeLocator,
        params: { back: pathname, closeTo: pathname, tab: isDelivery ? 'delivery' : 'pickup' },
      }}
      asChild
    >
      <Pressable
        accessibilityRole="button"
        accessibilityLabel={`${serviceMode}, ${label}. Change order location`}
        borderRadius={100}
        style={styles.locationButton}
        onPress={() =>
          logServiceModeBarClick({
            serviceMode,
            storeText: store.name || '',
          })
        }
      >
        <IconLocationFill size={16} color={tokens.colors.$houseRed} style={styles.fixedContent} />
        <Text.Ui size="sm" weight="bold" style={styles.fixedContent}>
          {serviceMode}
        </Text.Ui>
        <Text.Ui size="sm" numberOfLines={1} ellipsizeMode="tail" style={styles.locationText}>
          {label}
        </Text.Ui>
        <Text.Ui size="xs" weight="semibold" style={styles.changeText}>
          Change
        </Text.Ui>
      </Pressable>
    </Link>
  );
}

const styles = StyleSheet.create({
  locationButton: {
    width: '100%',
    minWidth: 0,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    paddingLeft: 12,
    paddingRight: 16,
    paddingVertical: 12,
    borderRadius: 100,
    borderWidth: 1,
    borderColor: tokens.colors.$blackOpacity10,
    backgroundColor: tokens.colors.$white,
  },
  locationText: {
    flex: 1,
    minWidth: 0,
  },
  fixedContent: {
    flexShrink: 0,
  },
  changeText: {
    color: tokens.colors.$houseRed,
    textDecorationLine: 'underline',
    marginLeft: 4,
    flexShrink: 0,
  },
});
